
import React, { useEffect, useState, useContext } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ScrollToTop from './components/UsefulComponent/ScrollToTop';
import CookieConsent from 'react-cookie-consent';
import { SportsProvider } from './utils/SportsProvider';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import { UserContext } from './components/login/LoginForm';
import { LoginForm } from './components/login/LoginForm';
import { Logout } from './components/login/logout';
import { Register } from './components/login/Register/Register';
import { AuthContext, AuthProvider } from './components/login/AuthContext';
import { FavoritesProvider } from './components/Favorite/FavoriteProvider';
import { CartProvider } from './components/Cart/CartContext';
import { TourProvider } from './OnBoardingTour/TourProvider';
import MainRouter from './MainRouter';
import translations from './utils/language/translations.json';
import './utils/language/i18n';
import 'react-toastify/dist/ReactToastify.css';
import './utils/axiosConfig';
import Headerv2 from './components/headerv2/Headerv2';
import FootlerV2 from './components/footer/footlerv2';
import axios from 'axios';


function App() {

  const [userData, setUserData] = useState({
    isLoggedIn: localStorage.getItem('isLoggedIn'),
  });
  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = new QueryClient();
  const { userId,csrfToken,preferredLanguage  } = useContext(AuthContext);

  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.FullUserprofilPage[key][currentLang];
  const [hideFooter, setHideFooter] = useState(false);
  const [activeView, setActiveView] = useState('');
  // const showLoginForm = () => setActiveView('login');
  // const showRegisterForm = () => setActiveView('register');

const isMobile = typeof window !== 'undefined'
  ? window.matchMedia('(max-width: 640px)').matches
  : false;


// useEffect(() => {
//   console.log('csrfToken',csrfToken)
//   const showLoginModal = () => {
//     setActiveView('login');
//     setIsModalOpen(true);
//   };

//   window.addEventListener("show-login-modal", showLoginModal);
//   return () => window.removeEventListener("show-login-modal", showLoginModal);
// }, []);

  // useEffect(() => {
  //   if (location.pathname.endsWith('/login') && !userId) {
  //     setActiveView('login');
  //     openModal();
  //   } else {
  //     closeModal();
  //   }
  // }, [location, userId]);

  
  // useEffect(() => {
  //   if (location.pathname.endsWith('/MessageDisplayParent')||location.pathname. && !userId) {
  //     setHideFooter(true);
   
  //   } else {
  //     setHideFooter(false)
  //   }
  // }, [location, userId]);

useEffect(() => {
  const p = (location?.pathname || '').toLowerCase();
  const onMessages =
    p === '/messagedisplayparent' ||
    p === '/messages' ||
    p.startsWith('/messages/');

  setHideFooter(onMessages || !userId);
}, [location.pathname, userId]);

  return (
    <QueryClientProvider client={queryClient}>
                 <ToastContainer
        position="top-center"
        newestOnTop
        closeOnClick
        theme="dark"
        style={{ zIndex: '2147483647' }}
      />
      <TourProvider>
        <AuthProvider>
          <UserContext.Provider value={{ ...userData, setUserData }}>
            <CartProvider>
              <FavoritesProvider userId={userId}>
                <SportsProvider>
              {/* <Navbar /> */}
              <Headerv2 open={open} setOpen={setOpen} />
                {/* {isModalOpen && (
                  <div className="overlay" onClick={closeModal}>
                    <div className="modal open login" onClick={(e) => e.stopPropagation()}>
                      <div className="modal-content">
                        <div className='retour'>
                          <a className='btn-base thrd small' onClick={closeModal} href='/'>
                            <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.66667 0.5C5.66667 1.03 5.14746 1.82143 4.62187 2.48571C3.94612 3.34286 3.13863 4.09071 2.21283 4.66143C1.51867 5.08929 0.677167 5.5 0 5.5M0 5.5C0.677167 5.5 1.51938 5.91072 2.21283 6.33857C3.13863 6.91 3.94612 7.65786 4.62187 8.51357C5.14746 9.17857 5.66667 9.97143 5.66667 10.5M0 5.5L17 5.5" stroke="white" strokeWidth="2" />
                            </svg>
                            <p>{t('Back')}</p>
                          </a>
                        </div>
                        <div className="sousmenus Stay" >
                          <a className={activeView === 'login' ? 'active' : ''} href="#" onClick={(e) => { e.preventDefault(); showLoginForm(); }}>{t('Login')}</a>
                          <a className={activeView === 'register' ? 'active' : ''} href="#" onClick={(e) => { e.preventDefault(); showRegisterForm(); }}>{t('Register')}</a>
                        </div>
                        {activeView === 'login' ? <LoginForm /> : <Register setActiveView={setActiveView} />}
                      </div>
                    </div>
                  </div>
                )} */}

                <ScrollToTop />
                <div className="content-wrapper" style={{opacity:`${open?'0.2':'1'}`}}>
                  <Routes>
                    <Route path="/*" element={<MainRouter lang="en" />} />
                    <Route path="/fr/*" element={<MainRouter lang="fr" />} />
                  </Routes>
                  {/* {!isModalOpen && location.pathname !== '/MessageDisplayParent' && <Footer />} */}
                  {!hideFooter && <FootlerV2 />}
                </div>
          
</SportsProvider>
              </FavoritesProvider>
            </CartProvider>
          </UserContext.Provider>
        </AuthProvider>
      </TourProvider>

<CookieConsent
  location="bottom"
  cookieName="cardsfolioConsent"
  buttonText="Accept"
  declineButtonText="Refuser"
  enableDeclineButton
  disableStyles
  containerClasses="cookie"
  contentClasses="cookie__content"
  buttonClasses="cookie__btn cookie__btn--accept"
  declineButtonClasses="cookie__btn cookie__btn--decline"
  expires={150}
>
  {t('cookieConsentMessage')}
</CookieConsent>


    </QueryClientProvider>
  );
}

export default App;
